import { Controller } from "react-hook-form";
import { Select } from "@/components/Select";
import React from "react";

interface RegionSelectProps {
  name: string;
  control: any;
  options: any[];
  onChange?: (value: string) => void;
  placeholder?: string;
  isLoading?: boolean;
}

const RegionSelect: React.FC<RegionSelectProps> = ({
  name,
  control,
  options,
  onChange,
  placeholder = "Select Region",
  isLoading,
}) => {
  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field }) => (
        <Select
          options={options}
          value={field.value || ""}
          onChange={(val: any) => {
            field.onChange(val || "");
            onChange?.(val || "");
          }}
          placeholder={placeholder}
          disabled={isLoading}
        />
      )}
    />
  );
};

export default RegionSelect;
